var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dynamic-crf',{attrs:{"crfId":"tbFrmPROMISNeuro","crfTitle":"How well you understand things"}})
}
var staticRenderFns = []

export { render, staticRenderFns }